import { render, staticRenderFns } from "./Pet.vue?vue&type=template&id=453ab5e7&scoped=true&"
import script from "./Pet.vue?vue&type=script&lang=js&"
export * from "./Pet.vue?vue&type=script&lang=js&"
import style0 from "./Pet.vue?vue&type=style&index=0&id=453ab5e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453ab5e7",
  null
  
)

export default component.exports